import React, { useCallback, useEffect, useRef, useState } from "react";

const INTERVALO = 7000;

/**
 * Rotador de mensajes del panel de acceso.
 *
 * Se detiene cuando el puntero está encima o cuando algo dentro tiene el foco,
 * para que nadie pierda de vista un texto que estaba leyendo, y no avanza solo
 * si el sistema pide menos movimiento.
 */
export default function AuthCarousel({ slides }) {
  const [activo, setActivo] = useState(0);
  const [pausado, setPausado] = useState(false);
  const menosMovimiento = useRef(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    menosMovimiento.current = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
  }, []);

  useEffect(() => {
    if (pausado || menosMovimiento.current || slides.length < 2) return;

    const id = window.setInterval(
      () => setActivo((i) => (i + 1) % slides.length),
      INTERVALO
    );

    return () => window.clearInterval(id);
  }, [pausado, slides.length]);

  const irA = useCallback((indice) => setActivo(indice), []);

  return (
    <div
      className="auth-carousel"
      onMouseEnter={() => setPausado(true)}
      onMouseLeave={() => setPausado(false)}
      onFocus={() => setPausado(true)}
      onBlur={() => setPausado(false)}
    >
      <div className="auth-carousel-viewport">
        {slides.map((slide, i) => (
          <div
            key={slide.titulo}
            className={`auth-slide ${i === activo ? "is-active" : ""}`}
            aria-hidden={i !== activo}
          >
            <h2 className="auth-slide-title">{slide.titulo}</h2>
            <p className="auth-slide-text">{slide.texto}</p>
          </div>
        ))}
      </div>

      <div className="auth-dots">
        {slides.map((slide, i) => (
          <button
            key={slide.titulo}
            type="button"
            className={`auth-dot ${i === activo ? "is-active" : ""}`}
            onClick={() => irA(i)}
            aria-label={slide.titulo}
            aria-current={i === activo}
          />
        ))}
      </div>
    </div>
  );
}
